module.exports = __webpack_public_path__ + "img/icon-buy-eth-mew.7551a462.svg";